import { IconButton, styled } from '@mui/material';
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';

export const StyledIconButton = styled(IconButton)``;

export const StyledQRButton = styled(QrCodeScannerIcon)`
  color: white;
`;
